import { getPropertyAuditLog } from '../../../api/Property';
import * as React from 'react';
import { Redirect } from 'react-router';
import { Props } from 'reactstrap/lib/Dropdown';
import { exportLog } from '../../../utilities/exportLog';
import LoadingOverlay from '../../common/LoadingOverlay';
import { momentDateFormat } from '../../../utilities/formatting';
import * as moment from 'moment';

interface State {
    logReceived: boolean;
}

class AuditLogPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            logReceived: false
        };
    }

    async componentDidMount() {
        let checkResult = await getPropertyAuditLog();
        if (checkResult.success && checkResult.data) {
            exportLog(`Property_Audit_Log_${moment().format(momentDateFormat)}`,
                checkResult.data);
            this.setState({
                logReceived: true
            });
        }
    }

    render() {
        if (this.state.logReceived === true) {
            return <Redirect to={{ pathname: '/admin' }} />;
        } else {
            return (
                <div className="position-relative w-100 h-75">
                    <LoadingOverlay show={true} inBootstrapColumn={false} />
                </div>
            );
        }
    }
}

export default AuditLogPage;


// WEBPACK FOOTER //
// ./src/components/pages/admin/AuditLogPage.tsx